enum Asset {
  AAVE = 'AAVE',
  APE = 'APE',
  ARB = 'ARB',
  AUTO = 'AUTO',
  BNB = 'BNB',
  BPT = 'BPT',
  BTCB = 'BTCB',
  BUSD = 'BUSD',
  BZRX = 'BZRX',
  BZRX_BNB = 'BZRX_BNB',
  CAKE = 'CAKE',
  COMP = 'COMP',
  CRV = 'CRV',
  CRV3 = 'CRV3',
  DAI = 'DAI',
  DOGE = 'DOGE',
  ETH = 'ETH',
  FRAX = 'FRAX',
  IAAVE = 'IAAVE',
  IAPE = 'IAPE',
  IARB = 'IARB',
  IAUTO = 'IAUTO',
  IBNB = 'IBNB',
  IBTCB = 'IBTCB',
  IBUSD = 'IBUSD',
  IBZRX = 'IBZRX',
  ICAKE = 'ICAKE',
  ICOMP = 'ICOMP',
  IDAI = 'IDAI',
  IDOGE = 'IDOGE',
  IETH = 'IETH',
  IFRAX = 'IFRAX',
  IKNC = 'IKNC',
  IKNCL = 'IKNCL',
  ILINK = 'ILINK',
  ILRC = 'ILRC',
  IMATIC = 'IMATIC',
  IMIM = 'IMIM',
  IMKR = 'IMKR',
  IOOKI = 'IOOKI',
  IOP = 'IOP',
  ISPELL = 'ISPELL',
  IUNI = 'IUNI',
  IUSDC = 'IUSDC',
  IUSDT = 'IUSDT',
  IWBTC = 'IWBTC',
  IWETH = 'IWETH',
  IYFI = 'IYFI',
  KNC = 'KNC',
  KNCL = 'KNCL',
  LINK = 'LINK',
  LRC = 'LRC',
  MATIC = 'MATIC',
  MIM = 'MIM',
  MKR = 'MKR',
  OOKI = 'OOKI',
  OP = 'OP',
  P125 = 'P125',
  SLP = 'SLP',
  SLP_OOKI_ETH = 'SLP_OOKI_ETH',
  SPELL = 'SPELL',
  STMATIC = 'STMATIC',
  SUSHI = 'SUSHI',
  UNI = 'UNI',
  UNKNOWN = 'UNKNOWN',
  USDC = 'USDC',
  USDT = 'USDT',
  vBZRX = 'vBZRX',
  vOOKI = 'vOOKI',
  WBNB = 'WBNB',
  WBTC = 'WBTC',
  WETH = 'WETH',
  WMATIC = 'WMATIC',
  WSTETH = 'WSTETH',
  YFI = 'YFI',
}

export default Asset
